import React, { FC } from 'react';

import { useModals } from '@contexts/common/ModalContext';

import AccountModal from '@modules/modals/common/AccountModal';
import BackModal from '@modules/modals/common/BackModal';
import ChainModal from '@modules/modals/common/ChainModal';
import WalletConnectModal from '@modules/modals/common/WalletConnectModal';
import WrongNetworkModal from '@modules/modals/common/WrongNetworkModal';
import AdvancedFilters from '@modules/modals/vaults/AdvancedFilters';
import ChangeTakeProfitTokenModal from '@modules/modals/vaults/ChangeTakeProfitTokenModal';
import CreatedVaultModal from '@modules/modals/vaults/CreadedVaultModal';
import FindFarmModal from '@modules/modals/vaults/FindFarmModal';
import ManageLiquidityModal from '@modules/modals/vaults/ManageLiquidityModal';
import NftModal from '@modules/modals/vaults/NftModal';
import PriceImpactModal from '@modules/modals/vaults/PriceImpactModal';
import VaultInformation from '@modules/modals/vaults/VaultInformation';
import VaultsVideoModal from '@modules/modals/vaults/VaultsVideoModal';
import AddRequestModal from '@modules/modals/voting/AddRequestModal';

import { MODAL_TYPES } from '@constants/common/modals.constants';

import {
  BackModalProps,
  ChangeProfitTokenModalProps,
  CreatedVaultModalProps,
  FindFarmModalModalProps,
  ManageLiquidityModalProps,
  NftModalProps,
  PriceImpactModalProps,
  VaultInformationProps,
} from '@app-types/common/modal.types';

const Modals: FC = () => {
  const { state } = useModals();

  return (
    <>
      {state.current === MODAL_TYPES.ADVANCED_FILTERS && <AdvancedFilters />}
      {state.current === MODAL_TYPES.CONNECT_WALLET_MODAL && (
        <WalletConnectModal />
      )}
      {state.current === MODAL_TYPES.CHAIN_MODAL && <ChainModal />}
      {state.current === MODAL_TYPES.ACCOUNT_MODAL && <AccountModal />}
      {state.current === MODAL_TYPES.WRONG_NETWORK_MODAL && (
        <WrongNetworkModal />
      )}
      {state.current === MODAL_TYPES.NFT_MODAL && (
        <NftModal {...(state.props as NftModalProps)} />
      )}
      {state.current === MODAL_TYPES.VAULT_INFORMATION && (
        <VaultInformation {...(state.props as VaultInformationProps)} />
      )}
      {state.current === MODAL_TYPES.BACK_MODAL && (
        <BackModal {...(state.props as BackModalProps)} />
      )}
      {state.current === MODAL_TYPES.PRICE_IMPACT_MODAL && (
        <PriceImpactModal {...(state.props as PriceImpactModalProps)} />
      )}
      {state.current === MODAL_TYPES.FIND_FARM_MODAL && (
        <FindFarmModal {...(state.props as FindFarmModalModalProps)} />
      )}
      {state.current === MODAL_TYPES.MANAGE_LIQUIDITY_MODAL && (
        <ManageLiquidityModal {...(state.props as ManageLiquidityModalProps)} />
      )}
      {state.current === MODAL_TYPES.CHANGE_PROFIT_TOKEN_MODAL && (
        <ChangeTakeProfitTokenModal
          {...(state.props as ChangeProfitTokenModalProps)}
        />
      )}
      {state.current === MODAL_TYPES.VAULTS_VIDEO_MODAL && <VaultsVideoModal />}
      {state.current === MODAL_TYPES.CREATED_VAULT_MODAL && (
        <CreatedVaultModal {...(state.props as CreatedVaultModalProps)} />
      )}
      {state.current === MODAL_TYPES.ADD_REQUEST_MODAL && <AddRequestModal />}
    </>
  );
};

export default Modals;
